export const ApiUrls = {
    User: {
        GetAccess: '/User/GetAccess',
        RefreshThirdPartyToken: '/User/RefreshThirdPartyToken',
        ClickPortal: "User/ClickPortal",
    },
    CompanyConfiguration: {
        GetCompanyConfig: 'CompanyConfiguration/GetCompanyConfig',
    },
}
